import { render, staticRenderFns } from "./frontPhotoOfIdCard.vue?vue&type=template&id=2518cdb4&"
import script from "./frontPhotoOfIdCard.vue?vue&type=script&lang=js&"
export * from "./frontPhotoOfIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports